import React from 'react'
import GestorAdmin from "../components/gestion-recursos/GestorAdmin";

export const AdminPage = () => {
    return (
        <GestorAdmin/>
    )
}
